import React from "react";

export default function FullStackImg(props) {
  const theme = props.theme;
  return (
    <img
      src={require(`../../assests/images/sangabriel/img_finca3.jpg`)}
      style={{
        maxWidth: "100%",
        height: "auto",
        boxSizing: "border-box",
        marginTop: "10%",
      }}
      alt="Lemon"
      fill={theme.accentColor}
    />
  );
}
